import { Component, OnInit, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { GeneralFilterPipe } from '../../pipes/general-filter.pipe';
import { TableFilterPipe } from '../../pipes/table-filter.pipe';
import { UntypedFormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-general-filter',
  templateUrl: './general-filter.component.html',
  styleUrls: ['./general-filter.component.scss']
})
export class GeneralFilterComponent implements OnInit {

  formFilter: UntypedFormControl = new UntypedFormControl(null, [Validators.minLength(3)]);

  filters: any = [];

  _src
  @Input()
  set src(value) {
    this._src = value;
    this.applyFilter();
  }
  get src() {
    return this._src;
  }

  _filteredData
  @Input()
  set filteredData(value) {
    if (value) {
      this._filteredData = value;
      setTimeout(() => {
        this.filteredDataChange.emit(this._filteredData);

      });
    }
  }
  get filteredData() {
    return this._filteredData;
  }
  @Output()
  filteredDataChange = new EventEmitter();

  @Input()
  placeholder: any;

  @Input()
  columns = [];

  constructor(private generalFilterPipe: GeneralFilterPipe, private tableFilter: TableFilterPipe) { }

  ngOnInit() {
    //this.formFilter.valueChanges.subscribe(() => this.applyFilter())
  }

  applyFilter() {
    this.columns = !this.columns ? [] : this.columns; //In case columns == undefined and can't read .length
    if (this.columns.length === 0) {
      let tempData = this.generalFilterPipe.transform(this.src, this.formFilter.value);
      this.filteredData = _.reduce(this.filters, (result, f) => {
        result = this.generalFilterPipe.transform(result, f);
        return result;
      }, tempData)
    } else {
      let tempData = this.tableFilter.transform(this.src, this.formFilter.value, this.columns);
      this.filteredData = _.reduce(this.filters, (result, f) => {
        result = this.tableFilter.transform(result, f, this.columns);
        return result;
      }, tempData)
    }

  }

  onAddFilterClicked() {
    if (this.formFilter.valid && this.formFilter.value) {
      this.filters.push(this.formFilter.value);
      this.formFilter.reset();
      this.formFilter.setValidators([Validators.minLength(3)])
      this.applyFilter();
    }
  }


  onClearFiltersClick() {
    this.filters = [];
    this.applyFilter();
  }

  onRemoveFilterClick(i) {
    _.pullAt(this.filters, i);
    this.applyFilter();
  }
}
